import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "./ui/card";
import { ArrowRight } from "lucide-react";
import "./ServicegebieteSection.css";

const ServicegebieteSection = () => {
  const servicegebiete = [
    {
      name: "Luzern",
      image: "https://images.unsplash.com/photo-1566789168779-73d46d92b809?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=60&fm=webp",
      alt: "Taxi Service Luzern am Vierwaldstättersee",
      description: "Historische Altstadt und Kapellbrücke",
      link: "/taxi-luzern",
      linkText: "Taxi Luzern Servicegebiet"
    },
    {
      name: "Weggis & Vitznau",
      image: "https://images.unsplash.com/photo-1540979388789-6cee28a1cdc9?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=60&fm=webp", 
      alt: "Taxi Service Weggis und Vitznau am See",
      description: "Wunderschöne Fahrten rund um den See",
      link: "/taxi-weggis",
      linkText: "Taxi Weggis & Vitznau Servicegebiet"
    },
    {
      name: "Schwyz & Brunnen",
      image: "https://images.unsplash.com/photo-1521292270410-a8c4d716d518?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=60&fm=webp",
      alt: "Taxi Service Schwyz und Brunnen - Traditionelle Schweizer Berglandschaft", 
      description: "Traditionelle Schweizer Berglandschaft",
      link: "/taxi-schwyz",
      linkText: "Taxi Schwyz & Brunnen Servicegebiet"
    },
    {
      name: "Zug",
      image: "https://images.unsplash.com/photo-1541696724920-864a966cc4c9?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=60&fm=webp",
      alt: "Taxi Service in Zug am Zugersee",
      description: "Moderne Stadt am Zugersee", 
      link: "/taxi-zug",
      linkText: "Taxi Zug Servicegebiet"
    },
    {
      name: "Arth-Goldau",
      image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=60&fm=webp",
      alt: "Taxi Service Arth-Goldau am Fuße der Rigi",
      description: "Tor zu Rigi und Pilatus",
      link: "/taxi-arth-goldau", 
      linkText: "Taxi Arth-Goldau Servicegebiet"
    }
  ];

  return (
    <section className="py-12 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">
            🗺️ Unsere Servicegebiete
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Von der historischen Stadt Luzern bis zu den malerischen Bergdörfern - 
            wir bringen Sie sicher an Ihr Ziel in der schönsten Region der Schweiz.
          </p>
        </div>

        {/* Service Cards Grid - Dark Theme mit CSS */}
        <div className="servicegebiete">
          {servicegebiete.map((gebiet, index) => (
            <Link
              key={index}
              to={gebiet.link}
              className="card"
            >
              {/* Image */}
              <img
                src={gebiet.image}
                alt={gebiet.alt}
                loading="lazy"
                decoding="async"
                width="400"
                height="300"
              />
              
              {/* Title */}
              <h3>{gebiet.name}</h3>
              
              {/* Description */}
              <p>{gebiet.description}</p>
              
              {/* SEO Link */}
              <p className="seo-link">
                <span>{gebiet.linkText}</span>
              </p>
            </Link>
          ))}
        </div>

        {/* Weitere Standorte - Compact Links */}
        <div className="mt-10 bg-gray-800 border border-gray-700 rounded-lg p-6">
          <h3 className="text-xl font-bold text-white mb-4 text-center">Weitere Standorte</h3>
          <div className="flex flex-wrap justify-center gap-3">
            {[
              { to: "/taxi-kriens", label: "Kriens" },
              { to: "/taxi-horw", label: "Horw" },
              { to: "/taxi-emmen", label: "Emmen" },
              { to: "/taxi-meggen", label: "Meggen" },
              { to: "/taxi-ebikon", label: "Ebikon" },
              { to: "/taxi-rothenburg", label: "Rothenburg" },
              { to: "/taxi-rotkreuz", label: "Rotkreuz" },
              { to: "/taxi-kussnacht", label: "Küssnacht" },
              { to: "/taxi-ingenbohl", label: "Ingenbohl" },
              { to: "/taxi-unteraegeri", label: "Unterägeri" },
              { to: "/taxi-walchwil", label: "Walchwil" },
              { to: "/taxi-vitznau", label: "Vitznau" },
              { to: "/taxi-gersau", label: "Gersau" },
              { to: "/taxi-rothenthurm", label: "Rothenthurm" },
              { to: "/taxi-root", label: "Root" },
              { to: "/flughafen-basel-transfer", label: "Flughafentransfer Basel" }
            ].map((link, i) => (
              <Link
                key={i}
                to={link.to}
                className="px-4 py-2 bg-gray-700 hover:bg-yellow-600 rounded-lg text-sm text-gray-300 hover:text-white transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12">
          <div className="bg-gray-800 border border-gray-700 rounded-lg p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-3">
              📞 Ihr Gebiet nicht dabei?
            </h3>
            <p className="text-gray-300 mb-6 text-lg">
              Kontaktieren Sie uns! Wir decken auch umliegende Gebiete ab.
            </p>
            <a
              href="tel:0766113131"
              className="inline-flex items-center bg-yellow-600 hover:bg-yellow-700 text-white px-8 py-4 rounded-lg font-bold transition-colors duration-200 text-lg"
            >
              📞 076 611 31 31
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicegebieteSection;